import type React from 'react'
import { useEffect, useRef } from 'react'

const useEffectAfterMount = (effect: React.EffectCallback, deps?: React.DependencyList) => {
  const isMounted = useRef(false)

  useEffect(() => {
    if (isMounted.current) {
      return effect()
    }

    isMounted.current = true
  }, deps)
}

export default useEffectAfterMount
